import { API_URL } from 'constants/data'
import { BASE_URL } from 'constants/url'

const CommentURLNames = {
  COMMENT: 'COMMENT',
  ARTICLE: 'article',
  WEBINAR: 'webinar',
  CLINICAL_CASE: 'clinicalCase',
  PODCAST: 'podcast',
}

const CommentURL = {
  [CommentURLNames.COMMENT]: `${API_URL}/api/comment`,
  [CommentURLNames.ARTICLE]: BASE_URL.ARTICLE,
  [CommentURLNames.WEBINAR]: BASE_URL.WEBINAR,
  [CommentURLNames.CLINICAL_CASE]: BASE_URL.CLINICAL_CASE,
  [CommentURLNames.PODCAST]: BASE_URL.PODCAST,
}

export { CommentURL, CommentURLNames }
